
'use strict';

angular.module('app')
    .controller('AuthCtrl',['$scope','$location','AuthService','Notification',
                function ($scope,$location,AuthService,Notification) {

        this.formLog = {};

        $scope.loading ={
            btnLogin :false,
            btnRecovery: false,
            btnSelect :false
        }

        $scope.signin = function(user){
            $scope.loading.btnLogin = true;
            if (this.formLog.$valid) {
                AuthService.signin(user)
                    .then(function successCallback(response) {
                        if(response.status == 201){
                            window.location = "/";
                        }
                    }, function errorCallback(response) {
                        $scope.loading.btnLogin = false;
                        if(response.status == 400){
                            for(var i = 0; i < response.data.length; i++){
                                Notification.error({title: "¡Oops!" ,message: response.data[i], template: "custom_template.html"});
                            }
                        }
                        if(response.status == 401){
                            Notification.error({title: "¡Oops!" ,message: response.data, template: "custom_template.html"});
                        }
                    });
              } else {
                $scope.loading.btnLogin = false;
                Notification.info({title:"Campos inválidos" ,message: 'Complete los campos en rojo del formulario.', template: "custom_template.html"});
                this.formLog.submitted = true;
            }
        };

        $scope.recoveryPassword = function(recovery){
            $scope.loading.btnRecovery = true;
            if (this.formRP.$valid) {
                AuthService.recovery(recovery)
                    .then(function successCallback(response) {
                        if(response.status == 201){
                            recovery = {};
                            $scope.showModalPassword = false;
                            $scope.loading.btnRecovery = false;
                            Notification.success({title:"¡Operación realizada con éxito!" ,message: "Se ha enviado un correo con las instrucciones para recuperar tu contraseña.", template: "custom_template.html"});
                        }
                    }, function errorCallback(response) {
                        $scope.loading.btnRecovery = false;
                        if(response.status == 400){
                            for(var i = 0; i < response.data.length; i++){
                                Notification.error({title: "¡Oops!" ,message: response.data[i], template: "custom_template.html"});
                            }
                        }
                        if(response.status == 401){
                            Notification.error({title: "¡Oops!" ,message: response.data, template: "custom_template.html"});
                        }
                    });
              } else {
                $scope.loading.btnRecovery = false;
                Notification.info({title:"Campos inválidos" ,message: 'Complete los campos en rojo del formulario.', template: "custom_template.html"});
                this.formRP.submitted = true;
            }
        };

       /* Levanta modal */
        $scope.toggleModal = function(type){
            /* Modal para crear miembro*/
            if(type == 1){
                $scope.showModalPassword = true;
            } 
        };

    }]);
